import axios from 'axios';
import Env from "../BsGetEnv";
import tc3 from './../config/tc3'
import BsGetLocation from './../BsGetLocation'
import bsGetCid from '../BsGetCid';
import bsUtil from '../BsUtil';
import vnLoginToast from '../VnLoginToast';
import BsUtil from '../BsUtil';
import 'crypto-js/enc-utf8'
import 'crypto-js/tripledes'
import 'crypto-js/sha1'
import * as crypto from 'crypto-js/core'
import BsGetDeviceId from '../BsGetDevice_id';
const service = axios.create({
  timeout: 8000 // 请求超时时间
});
service.options = {}
service.clearRequest = {
  source: {
    token: null,
    cancel: null
  }
}
const lane = bsUtil.queryString('lane') || '';
const mobile = Env.isAndroid ? '2' : '1';
// 是否为钉钉小程序
const isDingTalk = window.dd && window.dd.navigateTo
const ddcinfo = {
  latitude: '39.915526',
  longitude: '116.403847',
  location_time: '20190730152608',
  mobiletype: mobile,
  identifier: isDingTalk ? 'dingtalk_carpool.h5': Env.isDidaTaxi ? 'weixin.h5.driver' : 'weixin.h5',
  version: (Env.curAppVersion || '8.37.0') + '.app_h5',
  net: 'unknown',
  os: 'web',
  deviceId: ''
};
// 此处需要隐藏
const DES_KEY = 'bShORr6y6EQ=';

// ddcinfo增加转码加密
function encryptByDESModeCBC (message, key) {
  const keyHex = crypto.enc.Utf8.parse(key);
  const ivHex = crypto.enc.Utf8.parse(key);
  const encrypted = crypto.DES.encrypt(message, keyHex, {
    iv: ivHex,
    mode: crypto.mode.CBC,
    padding: crypto.pad.Pkcs7
  });
  return crypto.enc.Base64.stringify(encrypted.ciphertext);
}

function btoa_encode(ddcinfo) {
  return encryptByDESModeCBC(JSON.stringify(ddcinfo), DES_KEY);
}
// let udid = ''
// Env.inApplication && window.DIDASDK && window.DIDASDK.invoke('getUDID', {}, result => {
//   const res = JSON.parse(result)
//   // console.log('getUDID===>', res)
//   udid = res.udid || ''
// })

// 请求拦截器
service.interceptors.request.use(
  async config => {
    config.headers.lane = (config.headers && config.headers.lane) || lane;
    let location = await BsGetLocation(); // 经纬度
    if (config) {
        config.deviceId && (ddcinfo.deviceId = await BsGetDeviceId())
        delete config.deviceId;
        config.ddcinfo = config.ddcinfo || {};
        config.ddcinfo.latitude = String(config.ddcinfo.latitude || location.latitude);
        config.ddcinfo.longitude =  String(config.ddcinfo.longitude || location.longitude);
        config.ddcinfo.location_time = bsUtil.nowTime();
        config.headers.ddcinfo = btoa_encode({ ...ddcinfo, ...config.ddcinfo});
        const {access_token, cid} = await bsGetCid();
        const user_cid = cid;
        // 增加cid get请求
        config.params && (config.params.user_cid = user_cid)
        // post请求增加cid
        if (config.data && user_cid) {

            if (BsUtil.isString(config.data)) {
                config.data.indexOf('user_cid') === -1 && (config.data += '&user_cid=' + user_cid);
            } else {
                config.data.user_cid = user_cid;
            }
        }
        // 注释原因===>>>>接口会出现多个/web
        let auth = config.url.indexOf('/web') > -1?{ ...tc3(config.method, config.url.slice(config.url.indexOf('/web')).split('?')[0], config.params || config.data, config.headers) }:{};
        config.headers = {...{ user_cid, cid, 'x-access-token': access_token },...auth,...config.headers}
    }
    // 创建新的 CancelToken 实例
    service.clearRequest.source = axios.CancelToken.source()
    config.cancelToken = service.clearRequest.source.token
    return config;
  },
  error => {
    // 发送失败
    console.error(error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
    config => {
      if(config.data.code === 401 && !service.options.reset){
        vnLoginToast.vnLogin({
            isSilent: service.options.isSilent ? true : false, // 静默登录
            reset: true,
            success: () => {
              location.reload();
            }
        })
      }
      return config;
    },
    error => {
        // 统一处理cid和token没有的失败情况
        let res = error.response ? error.response.data : error;
        return Promise.reject(res);
    }
);

export default service;
